import {compact} from "lodash";
import React from "react";
import {formatName} from "src/utils/formatName";
import {readableList} from "src/utils/readableList";

import ProviderImageThumbnail from "../ProviderImageThumbnail";

/**
 * Renders the provider and location information for a group of slots.
 */
const ProviderHeader = ({
  firstName,
  lastName,
  credential,
  imageId,
  languages = [],
  address,
  alt = "",
}: {
  /**
   * The provider's first name
   */
  firstName: string;
  /**
   * The provider's last name
   */
  lastName: string;
  /**
   * The provider's credential
   */
  credential: string;
  /**
   * The languages spoken by the provider
   */
  languages?: string[];
  /**
   * The ID of the provider's cover image from `publicImages`
   */
  imageId: string;
  /**
   * The alt text for the image
   */
  alt?: string;
  /**
   * The address of the location to render
   */
  address: {
    street?: string;
    city?: string;
  };
}) => {
  return (
    <div className="flex items-center gap-3">
      <ProviderImageThumbnail imageId={imageId} alt={alt} />
      <div className="flex flex-col gap-2">
        <span className="heading-lg-bold leading-[1.2]">
          {formatName(firstName, lastName, credential)}
        </span>
        <div className="flex flex-col gap-1 text-gray-800 text-sm leading-[1.2] font-i">
          <span className="empty:hidden">{compact([address.street, address.city]).join(", ")}</span>
          {languages && languages.length > 0 ? (
            // This list is not localizable as of now.
            <span data-testid="provider-languages">Speaks {readableList(languages)}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProviderHeader);
